<template>
  <div id="app">
    <router-view :key="rkey"/>
  </div>
</template>

<script>
export default {
  methods: {
    onOpenHandler () {
      this.$router.replace({name: 'progress', params: { fromHome: true }})
    },
    onDataHandler (data) {
      if (data.kind === 'kms') {
        switch (data.cmd) {
          case 851: {
            this.$client.supporter = data.data.supporter
            this.$client.servernum = data.data.servernum
            this.$router.replace({name: 'video-chat', params: { fromHome: true }})
            break;
          }
          case 874: {
            this.$client.error = '잘못된 인증번호 입니다'
            this.rkey = Date.now()
            this.$router.replace({name: 'home'})
            break;
          }
          case 875: {
            this.$client.error = '상담원의 권한이 없습니다'
            this.rkey = Date.now()
            this.$router.replace({name: 'home'})
            break;
          }
          default:
            console.error(data)
        }
      }
      else if (data.kind === 'ap2p') {
        this.$client.$emit('control', data)
      }
    },
    onErrorHandler () {
      this.$router.replace({name: 'error'})
    },
    onCloseHandler () {
      this.$client.$emit('terminate')
    }
  },
  mounted () {
    this.$client.$on('open', this.onOpenHandler.bind(this))
    this.$client.$on('data', this.onDataHandler.bind(this))
    this.$client.$on('error', this.onErrorHandler.bind(this))
    this.$client.$on('close', this.onCloseHandler.bind(this))
  },
  beforeDestroy () {
    this.$client.$off('open')
    this.$client.$off('data')
    this.$client.$off('error')
    this.$client.$off('close')
  },
  data () {
    return {
      rkey: Date.now()
    }
  }
}
</script>

<style lang="scss">
  html, body {
    padding: 0;
    margin: 0;
    height: 100%;
    position: fixed;
    overflow: hidden;
  }
  body {
    background-color: #00284c;
    user-select: none;
  }
  #app {
    width: 100vw; height: 100vh;
    height: calc(var(--vh, 1vh) * 100);
    font-family: 'Malgun Gothic', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-overflow-scrolling: touch;
  }
  .loading-message {
    color: white;
    font-size: 14px;
    padding-top: 10px;
  }
</style>
